import emailjs from '@emailjs/browser'

export const SendEmail = async (type, body, file, fileBase64) => {
  const serviceID = process.env.REACT_APP_SEND_EMAIL_SERVICE_ID
  const userID = process.env.REACT_APP_SEND_EMAIL_USER_ID

  if (type === 'bancoDeTalentos') {
    const cvTemplateID = process.env.REACT_APP_SEND_EMAIL_CV_TEMPLATE_ID

    const data = {
      name: body.name,
      email: body.email,
      phone: body.phone,
      expertise: body.expertise || body.message,
      file: fileBase64,
      file_name: file ? file.name : 'curriculo.pdf',
    }

    return emailjs.send(serviceID, cvTemplateID, data, userID)
  } else {
    const contactTemplateID = process.env.REACT_APP_SEND_EMAIL_CONTACT_TEMPLATE_ID

    const subject = type === 'apoHealthCheck' ? 'APO Health Check' : 'Contato'

    const data = {
      subject,
      name: body.name,
      email: body.email,
      message: body.message,
      phone: body.phone,
    }

    return emailjs.send(serviceID, contactTemplateID, data, userID)
  }
}
